import { styles } from "../styles";

export default function DashboardTile({
  title,
  count,
  sublabel,
  onClick,
  htmlTitle,
}) {
  return (
    <div
      style={{ ...styles.card, cursor: onClick ? "pointer" : "default" }}
      onClick={onClick}
      title={htmlTitle}
    >
      <strong>{title}</strong>
      {count !== undefined && (
        <div style={{ fontSize: "28px" }}>{count}</div>
      )}
      {sublabel && (
        <div style={{ fontSize: "12px", color: "#666", marginTop: "4px" }}>
          {sublabel}
        </div>
      )}
    </div>
  );
}
